// extracted by mini-css-extract-plugin
export default {"root":"MaintenanceMode_root__FbtQ8","header":"MaintenanceMode_header__D7DFe","content":"MaintenanceMode_content__w36e5"};